import { AuthContext } from 'Modules/Auth/contexts/AuthContext';
import { useContext } from 'react';
import { useUser } from '@round/creatorbase-helpers/api-hooks';
import { ErrorFallback } from '@round/whitelabel-ui';
import { useCurrentCreatorbaseUser } from 'Modules/Auth/hooks/useCurrentCreatorbaseUser';
import useCurrentUserNonAgencyClients from 'Modules/Plans/Clients/hooks/useCurrentUserNonAgencyClients';
import NoAccess from './NoAccess/NoAccess';
import { FCWithChildren } from 'utility/utility.types';

const WhiteLabelAuthWrapper: FCWithChildren = ({ children }) => {
    const authContext = useContext(AuthContext);
    const { creatorbaseUserId } = useCurrentCreatorbaseUser();
    const { isLoading: isUserLoading, error: userError } = useUser(creatorbaseUserId);
    const { clients, status } = useCurrentUserNonAgencyClients();

    const hasCreatorBaseAccess = !!authContext.user?.creator_base_access;

    if (authContext.loading || isUserLoading || status === 'loading') {
        return null;
    }

    // A failed fetch is indistinguishable from "no creatorbase client" at the gate, so show the
    // error page rather than silently denying access to a legitimate creatorbase user.
    if (userError || status === 'error') {
        return <ErrorFallback />;
    }

    const hasNonAgencyClient = clients.some((client) => !client.is_agency);
    if (!hasCreatorBaseAccess || !hasNonAgencyClient) {
        return <NoAccess />;
    }

    return <>{children}</>;
};

export default WhiteLabelAuthWrapper;
